const utils = require('../../../lib/utils')
const baseTimeConfig = {
	hours: {
		min: 0,
		max: 23,
		nrOfDigits: 2,
		msFactor: 3600000,
		nativeInputGranted: true,
	},
	minutes: {
		min: 0,
		max: 59,
		nrOfDigits: 2,
		msFactor: 60000,
		nativeInputGranted: true,
	},
	seconds: {
		min: 0,
		max: 59,
		nrOfDigits: 2,
		msFactor: 1000,
		nativeInputGranted: false,
	},
	milliseconds: {
		min: 0,
		max: 999,
		nrOfDigits: 3,
		msFactor: 1,
		nativeInputGranted: false,
	}
}

module.exports = {
	model: {
		initialized: false, // has this element's config been initialized or not
		dataTIME: '', // '16:55:15.049'
		config: {
			isActivated: false,
			isOptional: false,
			disabled: false,
			nullAble: true,
			defaultDataTIME: null,
			timeParts: ['hours', 'minutes'],
			// timeParts: ['hours', 'minutes', 'seconds', 'milliseconds'],
			timeRange: {
				// min: '08:30:00.000',
				// max: '17:00:00.000'
			},
			maxExclusive: false,
			hours: {
				stepSize: 1,
				beforeSymbol: '',
				placeholder: '--',
			},
			minutes: {
				stepSize: 15,
				beforeSymbol: ':',
				placeholder: '--',
			},
			seconds: {
				stepSize: 15,
				beforeSymbol: ':',
				placeholder: '--',
			},
			milliseconds: {
				stepSize: 100,
				beforeSymbol: '.',
				placeholder: '---',
			},
			useNativeInputElement: undefined, // if true a native select-box will be used instead of the mousewheel controlled divs. if undefined the environment device type decides if it is necessary to use the native select-box.
			nativeInputList: [], // will be initialized via fieldConfig if not defined.
			placeholder: '', // will be initialized via fieldConfig if not defined
			// placeholderKey: '', // if set this will be treated as i18next source for the used placeholder
		}
	},

	events: {
		onChange: {
			type: 'change',
			action: function(event){
				const self = event.data.component
				const fieldConfig = self.model.config || {}
				let $target, value

				if(fieldConfig.useNativeInputElement){
					event.preventDefault()
					event.stopImmediatePropagation()

					if(($target = $(event.target).closest('select')).length > 0){
						value = $target.val()
						self.setTime(value)
					}
				}
			}
		},
		toggleOptional: {
			type: 'click',
			action: function(event) {
				const self = event.data.component
				const fieldConfig = self.model.config || {}

				if(fieldConfig.isOptional){
					const $select = $(event.target).closest('select')
					if($select.length > 0) return;

					const activationToggle = getComponent(self.$.find('[data-field-code="activated"]'), true)
					if(activationToggle) activationToggle.toggle();
				}
			}
		},
		hoverIn: {
			type: 'mouseenter',
			selector: '.timePart',
			action: function(event){
				const self = event.data.component
				const fieldConfig = self.model.config || {}

				if(!fieldConfig.useNativeInputElement){
					if(fieldConfig.disabled) return;
					const $target = $(event.target).closest('.timePart')
					let activeElement, element

					if((activeElement = $target.data('timePart'))){
						for(element in fieldConfig.orderMatrix){
							if(element == activeElement){
								self.model.active[element] = true
								self.$.addClass('active')
								$target.addClass('active')
							} else {
								self.model.active[element] = false
							}
						}
					}
				}
			}
		},
		hoverOut: {
			type: 'mouseleave',
			selector: '.timePart',
			action: function(event){
				const self = event.data.component
				const fieldConfig = self.model.config || {}

				if(!fieldConfig.useNativeInputElement){
					if(fieldConfig.disabled) return;
					let element, $target
					if(($target = $(event.target).closest('.timePart')).length > 0){
						$target.removeClass('active')
					}
					for(element in fieldConfig.orderMatrix){
						self.model.active[element] = false
					}
					self.$.removeClass('active')
				}
			}
		},
		hoverChange: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				const self = event.data.component
				const fieldConfig = self.model.config || {}

				if(!fieldConfig.useNativeInputElement){
					if(fieldConfig.disabled || (fieldConfig.isOptional && !fieldConfig.isActivated)) return;
					let element
					for(element in fieldConfig.orderMatrix){
						if(self.model.active[element]){
							let diff = -1
							if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
								diff = 1
							}
							self.change(diff, element)
							break
						}
					}
				}
			}
		}
	},

	methods: {
		prepare(storage){
			this.initConfig(storage)
		},

		initConfig(storage){
			if(this.model.initialized) return;
			this.model.initialized = true

			const fieldConfig = this.model.config || {}
			utils.refMerge(fieldConfig, baseTimeConfig)
			let element

			if(!fieldConfig.nullAble && !fieldConfig.defaultDataTIME){
				fieldConfig.defaultDataTIME = ''

				for(const timePart of fieldConfig.timeParts || []) {
					const timePartConfig = fieldConfig[timePart] || {}
					fieldConfig.defaultDataTIME += `${timePartConfig.beforeSymbol || ''}${String('').padStart(timePartConfig.nrOfDigits || 2, '0')}`
				}
			}

			// prepare order matrix
			fieldConfig.orderMatrix = {}
			fieldConfig.orderMatrixKeys = fieldConfig.timeParts
			let o
			for(o in fieldConfig.orderMatrixKeys){
				fieldConfig.orderMatrix[fieldConfig.orderMatrixKeys[o]] = o
				fieldConfig[fieldConfig.orderMatrixKeys[o]].last = false
			}
			fieldConfig[fieldConfig.orderMatrixKeys[o]].last = true

			// prepare timeRanges
			fieldConfig.preparedTimeRange = {}
			fieldConfig.absoluteTimes = {}
			if(fieldConfig.timeRange){
				for(const l in fieldConfig.timeRange){
					fieldConfig.preparedTimeRange[l] = {}
					let limit
					if((limit = fieldConfig.timeRange[l])){
						let value, timePart
						const timeParts = this.timeToParts(limit)
						fieldConfig.absoluteTimes[l] = 0
						for(timePart in timeParts || []){
							if(fieldConfig.orderMatrix[timePart]){
								value = timeParts[timePart]
								fieldConfig.preparedTimeRange[l][timePart] = value
								fieldConfig.absoluteTimes[l] += value * fieldConfig[timePart].msFactor
							}
						}
					}
				}

				if(!fieldConfig.preparedTimeRange.min) fieldConfig.preparedTimeRange.min = {};
				if(!fieldConfig.preparedTimeRange.max) fieldConfig.preparedTimeRange.max = {};
				for(element in fieldConfig.orderMatrix){
					if(fieldConfig.preparedTimeRange.min[element] === undefined) fieldConfig.preparedTimeRange.min[element] = fieldConfig[element].min;
					if(fieldConfig.preparedTimeRange.max[element] === undefined) fieldConfig.preparedTimeRange.max[element] = fieldConfig[element].max;
				}
			}

			// use native input element if there is no mousewheel and this flag has not been set already.
			if(fieldConfig.useNativeInputElement === undefined){
				const deviceType = ((this.activeEnvironment || {}).device || {}).type || ''
				if(deviceType === 'phone' || deviceType === 'tablet'){
					fieldConfig.useNativeInputElement = true
				}
			}

			// prepare option-list of native select box if necessary
			if(fieldConfig.useNativeInputElement && utils.collectionSize(fieldConfig.nativeInputList) < 1){
				fieldConfig.nativeInputList = []

				let setDefaultPlaceholder = false
				if(!fieldConfig.placeholder){
					if(fieldConfig.placeholderKey){
						fieldConfig.placeholder = storage.__(fieldConfig.placeholderKey)
					} else {
						setDefaultPlaceholder = true
					}
				}

				let elements = [], i
				for(const timePart of fieldConfig.timeParts || []){
					const timePartConfig = fieldConfig[timePart] || {}

					// generate placeholder if necessary
					if(timePartConfig.nativeInputGranted && setDefaultPlaceholder){
						fieldConfig.placeholder = `${timePartConfig.placeholder || ''}${timePartConfig.beforeSymbol + fieldConfig.placeholder}`
					}

					if(timePartConfig.nativeInputGranted){
						const stepSize = timePartConfig.stepSize || 1

						const newElements = []
						for(i = timePartConfig.min; i <= timePartConfig.max; i += stepSize){
							newElements.push({
								ms: 	i * timePartConfig.msFactor,
								title: 	`${timePartConfig.beforeSymbol || ''}${String(i).padStart(timePartConfig.nrOfDigits || 2, '0')}`,
							})
						}

						if(elements.length < 1){
							elements = newElements
						} else {
							const finalElements = []
							for(const e in elements){
								for(const ne in newElements){
									finalElements.push({
										ms: 	elements[e].ms + newElements[ne].ms,
										title: 	`${elements[e].title}${newElements[ne].title}`,
									})
								}
							}
							elements = finalElements
						}
					}
				}

				// respect timeRange for potential values
				const min = fieldConfig.absoluteTimes.min || -1
				const max = fieldConfig.absoluteTimes.max || -1
				if(min >= 0 || max >= 0){
					const newElements = []
					for(const time of elements) {
						if(
							(min < 0 || time.ms >= min)
							&&
							(max < 0 || time.ms < max || (time.ms === max && !fieldConfig.maxExclusive))
						) {
							newElements.push(time.title)
						}
					}

					fieldConfig.nativeInputList = newElements
				} else {
					fieldConfig.nativeInputList = elements.map(value => value.title)
				}
			}

			// init model if necessary
			this.model.active = {}
			this.model.value = {}
			this.model.formatted = {}
			let elementConfig, values = {}
			if(!this.model.dataTIME && fieldConfig.disabled && (fieldConfig.isActivated || !fieldConfig.isOptional)){
				this.model.dataTIME = fieldConfig.defaultDataTIME
			}
			if(this.model.dataTIME){
				values = this.timeToParts(this.model.dataTIME)
			}
			for(element in fieldConfig.orderMatrix){
				if((elementConfig = fieldConfig[element])){
					this.model.active[element] = false
					if(this.model.dataTIME){
						this.model.value[element] = values[element]
					} else {
						this.model.value[element] = -1
					}
				}
			}

			// set activated toggle if necessary
			if(fieldConfig.isOptional && this.model.dataTIME){
				fieldConfig.isActivated = true
			}
		},

		change: function(diff, element, internalCall, initCall){
			const fieldConfig = this.model.config || {}

			if(diff !== null) {

				if(diff === undefined) diff = 1;

				if(!element){
					element = fieldConfig.orderMatrixKeys[0]
				}

				if(!internalCall){
					// set undefined values if necessary
					for(const e in this.model.value){
						if(this.model.value[e] < 0){
							this.change(0, e, true)
						}
					}
				}

				const elementOrder = fieldConfig.orderMatrix[element]
				const config = fieldConfig[element]
				const val = this.model.value[element] || 0
				let nextVal = (config.stepSize * diff) + val

				// reset in effect?
				if(diff === 0){
					if(val < 0){
						// take min value as default
						nextVal = config.min
					} else if(nextVal % config.stepSize != 0) {
						// correct preset value if it is not within given stepSize intervals
						nextVal = Math.round(nextVal / config.stepSize) * config.stepSize
					}
				}
				// lower limit functionality
				if (nextVal < config.min){
					if(elementOrder > 0){
						this.change(-1, fieldConfig.orderMatrixKeys[elementOrder - 1], true)
					}
					nextVal = config.max + 1 - config.stepSize
				}
				// upper limit functionality
				else if(nextVal > config.max){
					if(elementOrder > 0){
						this.change(1, fieldConfig.orderMatrixKeys[elementOrder - 1], true)
					}
					nextVal = config.min
				}

				this.model.value[element] = nextVal


				if(!internalCall){
					const absoluteTimes = fieldConfig.absoluteTimes
					absoluteTimes.value = 0
					for(const e in fieldConfig.orderMatrix){
						absoluteTimes.value += this.model.value[e] * fieldConfig[e].msFactor
					}

					let newValues = false
					let maxValuesInCharge = false

					if(absoluteTimes.min > 0 && absoluteTimes.value < absoluteTimes.min){
						if(diff >= 0) {
							newValues = fieldConfig.preparedTimeRange.min
						} else {
							newValues = fieldConfig.preparedTimeRange.max
							maxValuesInCharge = true
						}
					} else if(
						(absoluteTimes.max > 0)
						&&
						(
							absoluteTimes.value > absoluteTimes.max
							||
							(fieldConfig.maxExclusive && absoluteTimes.value == absoluteTimes.max)
						)
					){
						if(diff <= 0){
							newValues = fieldConfig.preparedTimeRange.max
							maxValuesInCharge = true
						} else {
							newValues = fieldConfig.preparedTimeRange.min
						}
					}

					if(newValues){
						for(const e in fieldConfig.orderMatrix){
							this.model.value[e] = newValues[e]
							this.prepareFormatted(newValues[e], e)
						}

						if(maxValuesInCharge && fieldConfig.maxExclusive){
							this.change(-1, fieldConfig.orderMatrixKeys[fieldConfig.orderMatrixKeys.length - 1], true)
						}
						this.prepareTime()
						this.refreshGui()
						return
					}
				}

				this.prepareFormatted(nextVal, element)
			}

			if(!internalCall){
				this.prepareTime()
				this.refreshGui(diff === null)

				// tell parent form that this field has been changed if necessary
				if(!fieldConfig.disabled){
					let value = null, absoluteTime = 0
					if(diff !== null && (!fieldConfig.isOptional || fieldConfig.isActivated)){
						value = this.model.dataTIME
						absoluteTime = fieldConfig.absoluteTimes.value
					}
					if(!initCall || this.model.initAbsoluteTime !== absoluteTime){
						this.parent(function(parentComponent){
							parentComponent.trigger('onChildChanged', {
								fieldCode: this.model.fieldCode,
								value: value,
								additionals: {
									absoluteTime: absoluteTime
								}
							})
						})
					}
				}
			}
		},

		setAbsoluteInitTime: function(){
			this.model.initAbsoluteTime = 0
			if(this.model.dataTIME){
				const timeParts = this.timeToParts(this.model.dataTIME)
				let timePart
				for(timePart in timeParts){
					this.model.initAbsoluteTime += (this.model.config[timePart].msFactor * timeParts[timePart])
				}
			}
		},

		prepareFormatted: function(value, element){
			this.model.formatted[element] = String(value || 0).padStart((this.model.config[element] || {}).nrOfDigits || 2, '0')
		},

		prepareTime: function(){
			let element
			this.model.dataTIME = ''
			for(element in this.model.config.orderMatrix){
				this.model.dataTIME += this.model.config[element].beforeSymbol + this.model.formatted[element]
			}
		},

		refreshGui: function(forcePlaceholder = false){
			const fieldConfig = this.model.config || {}
			let element
			if(fieldConfig.useNativeInputElement){
				let value = ''
				for(element in fieldConfig.orderMatrix){
					if(fieldConfig[element].nativeInputGranted){
						let formatted = this.model.formatted[element]
						if(forcePlaceholder || (fieldConfig.isOptional && !fieldConfig.isActivated)){
							formatted = fieldConfig[element].placeholder
						}
						value = `${value}${fieldConfig[element].beforeSymbol + formatted}`
					}
				}
				const $select = this.$.find('select')
				if($select.length > 0){
					if(value === fieldConfig.placeholder){
						$select.val(null)
					} else {
						$select.val(value)
					}

					if(fieldConfig.isOptional){
						if(fieldConfig.isActivated && !fieldConfig.disabled){
							$select.removeAttr('disabled')
						} else {
							$select.attr('disabled', '')
						}
					}
				}

			} else {
				for(element in fieldConfig.orderMatrix){
					let formatted = this.model.formatted[element]
					if(fieldConfig.isOptional && !fieldConfig.isActivated){
						formatted = fieldConfig[element].placeholder
					}
					this.model.$elements[element].html(fieldConfig[element].beforeSymbol + formatted)
				}
			}
		},

		timeToParts: function(time){
			const parts = String(time).split('+')
			if(parts.length > 1){
				time = parts[0]
			}
			const elements = String(time).split(/[:\.]/)
			const values = {}
			let element
			for(const elementIndex in elements || []){
				// prevent timezones
				if(element = this.model.config.orderMatrixKeys[elementIndex]){
					values[element] = parseInt(elements[elementIndex])
				}
			}

			return values
		},

		setTime: function(time){
			const fieldConfig = this.model.config || {}
			if(fieldConfig.disabled) return;

			let values, element, config
			if(time){
				values = this.timeToParts(time)
				for(element in fieldConfig.orderMatrix){
					if(config = fieldConfig[element]){
						this.model.value[element] = values[element]
						this.change(0, element, !config.last)
					}
				}
			} else if(fieldConfig.nullAble) {
				this.change(null)
			}
		},

		getTime: function(){
			return {
				value: this.model.dataTIME,
				absoluteValue: (this.model.config.absoluteTimes || {}).value || 0
			}
		},

		disable: function(){
			const fieldConfig = this.model.config || {}
			fieldConfig.disabled = true
			if(fieldConfig.isOptional){
				const activationToggle = getComponent(this.$.find('[data-field-code="activated"]'), true)
				if(activationToggle){
					activationToggle.disable()
				}
			}
			if(this.model.$inputElement){
				this.model.$inputElement.attr('disabled', '')
			}
			this.$.addClass('disabled')
			this.change(0)
		},

		enable: function(){
			const fieldConfig = this.model.config || {}
			fieldConfig.disabled = false
			if(fieldConfig.isOptional){
				const activationToggle = getComponent(this.$.find('[data-field-code="activated"]'), true)
				if(activationToggle){
					activationToggle.enable()
				}
			}
			if(this.model.$inputElement) {
				this.model.$inputElement.removeAttr('disabled')
			}
			this.$.removeClass('disabled')
			this.change(0)
		},
	},

	hooks: {
		postAttach: function($element, options){
			const fieldConfig = this.model.config || {}
			let element

			// prepare $elements
			if(fieldConfig.useNativeInputElement && !this.model.$inputElement){
				this.model.$inputElement = $element.find('select')
			} else if(!fieldConfig.useNativeInputElement && !this.model.$elements){
				this.model.$elements = {}
				for(element in fieldConfig.orderMatrix){
					this.model.$elements[element] = $element.find('.timePart[data-time-part="' + element + '"]')
				}
			}

			this.setAbsoluteInitTime()

			for(element in fieldConfig.orderMatrix){
				// check $elements
				if(!fieldConfig.useNativeInputElement && (!this.model.$elements[element] || this.model.$elements[element].length <= 0)) {
					throw Error('TimePickers ' + element + ' Element Missing')
					// console.error('TimePickers ' + element + ' Element Missing') // for debugging purposes only
				} else if(fieldConfig.useNativeInputElement && (!this.model.$inputElement || this.model.$inputElement.length <= 0)){
					throw Error('TimePickers ' + element + ' InputElement Missing')
					// console.error('TimePickers ' + element + ' InputElement Missing') // for debugging purposes only
				} else if(!options.refresh && this.model.dataTIME) {
					// refresh last element external (NOTE: range recognition and gui refresh will be respected)
					this.change(0, element, !fieldConfig[element].last, fieldConfig[element].last)
				}
			}

			if(!options.refresh && !this.model.dataTIME && fieldConfig.defaultDataTIME){
				// set default time in a way for all parents to get a chance to react to this change.
				this.setTime(fieldConfig.defaultDataTIME)
			}
		},

		onChildChanged($element, options){
			if(options.fieldCode === 'activated'){
				this.model.config.isActivated = !!options.value
				if(this.config.isReady){
					this.change(0)
				}
			}
		},
	}
}